module.exports = __webpack_public_path__ + "static/media/bottom@2x.58d91a3f.png";